const store = {
    namespaced: true,
    state() {
        return {
            isSearchWindowOpen: false,
        }
    },
    getters: {
        getIsSearchWindowOpen: (state) => state.isSearchWindowOpen
    },
    mutations: {
        SET_SEARCH_WIDNOW_OPEN: (state, flag) => state.isSearchWindowOpen = flag,
    },
    actions: {
        setSearchWindowOpen: ({ commit }) => commit('SET_SEARCH_WIDNOW_OPEN'),
    }
}

export default store